/* eslint-disable class-methods-use-this */
import instance from "axios";
import jwtDecode from "jwt-decode";

import {
  API_LOGIN_URL,
  API_LOGOUT_URL,
  API_USER_URL,
  COMMON_HEADER_CONFIG
} from "src/config";
import axios from "src/utils/axios";

class AuthService {
  setAxiosInterceptors = ({onLogout}) => {
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          this.setSession("", null);

          if (onLogout) {
            onLogout();
          }
        }

        return Promise.reject(error);
      }
    );
  };

  handleAuthentication() {
    const accessToken = this.getAccessToken();

    if (!accessToken) {
      return;
    }

    if (this.isValidToken(accessToken)) {
      this.setSession("accessToken", accessToken);
    } else {
      this.setSession("", null);
    }
  }

  loginWithEmailAndPassword = (email, password, fcmToken) =>
    new Promise((resolve, reject) => {
      const data = JSON.stringify({
        email: email.toLowerCase(),
        password,
        platform_name: "AP"
      });

      const config = {
        method: "post",
        url: API_LOGIN_URL,
        headers: {
          ...COMMON_HEADER_CONFIG,
          "Content-Type": "application/json",
          "x-device-token": fcmToken,
          token: undefined,
          "x-api-language": "vi"
        },
        data
      };
      instance(config)
        .then((response) => {
          if (response.data.data) {
            this.setSession("accessToken", response.data.data.token);
            this.setSession("userId", response.data.data.user_info.id);
            this.setSession(
              "userName",
              `${response.data.data.user_info.first_name} ${response.data.data.user_info.last_name}`
            );
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  loginInWithToken = (userId = "") =>
    new Promise((resolve, reject) => {
      const access_token = localStorage.getItem("accessToken") || undefined;
      if (access_token) {
        instance
          .get(`${API_USER_URL}/user/${userId}`, {
            headers: {
              ...COMMON_HEADER_CONFIG,
              Authorization: `Bearer ${access_token}`
            }
          })
          .then((response) => {
            if (response.data.data) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          })
          .catch((error) => {
            resolve(error.response);
          });
      } else {
        this.logout();
      }
    });

  logout = () => {
    this.setSession("", null);
  };

  setSession = (name, value) => {
    if (value) {
      localStorage.setItem(name, value);
      axios.defaults.headers.common.Authorization = `Bearer ${value}`;
    } else {
      // localStorage.removeItem(name);
      localStorage.clear();
      delete axios.defaults.headers.common.Authorization;
    }
  };

  getAccessToken = () => localStorage.getItem("accessToken");

  isValidToken = (accessToken) => {
    if (!accessToken) {
      return false;
    }

    const decoded = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  };

  writeLogWhenLogout = () => {
    return new Promise((resolve, reject) => {
      const access_token = localStorage.getItem("accessToken") || undefined;
      if (access_token) {
        const config = {
          method: "post",
          url: API_LOGOUT_URL,
          headers: {
            ...COMMON_HEADER_CONFIG,
            Authorization: `Bearer ${access_token}`
          },
          data: {
            token: access_token
          }
        };
        instance(config)
          .then((response) => {
            if (response.data.code === "success") {
              resolve(response);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error.code);
          });
      }
    });
  };

  isAuthenticated = () => !!this.getAccessToken();
}

const authService = new AuthService();

export default authService;
